// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 5463); hand-edits allowed (see docs/architecture.md)

/** `this.GUM_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_GUM_DEF(): any {
  return {
    "bazooka": 100,
    "grenade": 100,
    "cluster_bomb": 1,
    "mortar": 1,
    "pistol": 3,
    "prod": 100,
    "fireball": 100,
    "jet_pack": 1,
    "skip_go": 100,
    "mine": 1,
    "teleport": 1
  };
}
